/**
 * Charte graphique SIMPLON Côte d'Ivoire
 * Couleurs principales: Rouge et Blanc
 */

export const colors = {
  // Couleurs principales
  primary: {
    50: '#fee2e2',
    100: '#fecaca',
    200: '#fca5a5',
    300: '#f87171',
    400: '#ef4444',
    500: '#dc2626', // Rouge principal
    600: '#b91c1c', // Rouge principal utilisé
    700: '#991b1b',
    800: '#7f1d1d',
    900: '#7f1d1d',
  },
  
  // Couleurs secondaires (gris pour le contraste)
  gray: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827',
  },
  
  // Couleurs d'état
  success: {
    light: '#d1fae5',
    DEFAULT: '#10b981',
    dark: '#047857',
  },
  
  warning: {
    light: '#fef3c7',
    DEFAULT: '#f59e0b',
    dark: '#d97706',
  },
  
  error: {
    light: '#fee2e2',
    DEFAULT: '#ef4444',
    dark: '#dc2626',
  },
  
  info: {
    light: '#dbeafe',
    DEFAULT: '#3b82f6',
    dark: '#2563eb',
  },
  
  // Neutre
  white: '#ffffff',
  black: '#000000',
};

export default colors;

